const OUT_OF_STOCK_REASONS = [
    'Vendor Short - Case Short, Ct/Cs discrepancy',
    'Inventory Accuracy (Ops related)',
    'Inventory Accuracy (Planning related)',
    'Gapping',
    'Late Truck',
    'Quality Issue - Rejection, QC pull',
    'No more inventory on hand',
    'Late Truck - DLVD',
    'Other',
];

export { OUT_OF_STOCK_REASONS };
